import React from 'react';
import { Toaster } from 'sonner';
export default function AuthLayout({ children }) {
  return (
    <main
      className="
      min-h-full h-screen 
      flex items-center justify-center 
      py-12 px-4 sm:px-6 lg:px-8
      "
    >
      <Toaster richColors position="bottom-center" className="select-none" />
      {children}
    </main>
  );
}
